import { Component, ElementRef, ViewChild, inject } from '@angular/core';
import { DatePipe, Location } from '@angular/common';
import {SettingsService} from 'src/app/services/settings.service'
import { Router ,ActivatedRoute} from '@angular/router';
import { PageEvent } from '@angular/material/paginator';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators,FormControl } from '@angular/forms'
import { ToastMsg, ToastmsgService } from 'src/app/util/toastmsg/toastmsg.service';
import { Observable, Subscription, map, startWith } from 'rxjs';
import {AirManagementService}  from 'src/app/services/air-management.service'
import {PaymentConfigService}  from 'src/app/services/payment-config.service'
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import {LiveAnnouncer} from '@angular/cdk/a11y';
import { MatChipInputEvent } from '@angular/material/chips';
import {StaticdataService}  from 'src/app/services/staticdata.service'
@Component({
  selector: 'app-branch',
  templateUrl: './branch.component.html',
  styleUrls: ['./branch.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({height: '0px', minHeight: '0'})),
      state('expanded', style({height: '*'})),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class BranchComponent {
  fileSelected:boolean=false
  selectedFile:any=null
    action:any
  airportRegFg!:FormGroup
  showAirportPopup:boolean=false
  airportData:any=[]
  columnsAirportsDisplay: string[] = ['status','name','city','creationTime'];
  expandedElement!: any | null;
  totalElements:any=0
  pageStr:any={
    number:'0',
    size:'10'
  }
  searchText:any=""

constructor(private fb : FormBuilder,private AirManagementService:AirManagementService,private toastMsgService : ToastmsgService){
this.sourceCodelist()
this.carrierCodelist()
  this.dataFields()
  this.AirportList()

}
  formatDate(val: Date) {
    let convertedValue:any = ""
    if(val){
    let datepipe = new DatePipe("en");
    //return datepipe.transform(val, "dd-MM-yyyy hh:mm:ss");
    convertedValue =  datepipe.transform(val, "dd-MM-yyyy hh:mm:ssa");
    }
    return convertedValue;
  }

  rowAirportClick(element:any){
    this.action="update"
    this.showAirportPopup=true

    this.airportRegFg=this.fb.group({
      "branchCode":[element?.branchCode,[Validators.required]],
      "city": [element?.city,[Validators.required]],
      "status": [element?.status],
      "helplineEmail":[element?.helplineEmail,[Validators.required,Validators.pattern(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)]],
      "helplineContactNumber":[element?.helplineContactNumber,[Validators.required]],
      "address":[element?.address,[Validators.required]],
      "gstNumber":[element?.gstNumber,[Validators.required]], 
      "id":[element?.id]
    });
    
  }


  closePopup(){
this.showAirportPopup=false
this.dataFields()
  }
  dataFields(){
  
    this.airportRegFg=this.fb.group({

      "branchCode":['',[Validators.required]],
      "city": ['',[Validators.required]],
      "helplineEmail":['',[Validators.required,Validators.pattern(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)]],
      "helplineContactNumber":['',[Validators.required]],
      "address":['',[Validators.required]],
      "gstNumber":['',[Validators.required]],
      "status": ['A'],

      
    });
  }
  AddAirport() {
    this.AirManagementService.saveBranch(this.airportRegFg.value)
      .subscribe({
        next : (res) => {
          if(res.status==200 || res.status==201) {
            this.toastMsgService.setMsg({msg : "Branch Added Successfully!",msgTitle : "Success", msgType : "I"});
           // this.router.navigate(["/sign-in"]);
           this.dataFields();
           this.AirportList()

           this.showAirportPopup=false

          } else {
            const body : any = res.body;
            this.registerAirportErrorMsg(res.status,body?.result);
          } 

        },error : (err) => {

          this.registerAirportErrorMsg(err.status,err.error);
        }
      }
    )
  }

  updateBranch() {
  
    this.AirManagementService.saveBranch(this.airportRegFg.value)
      .subscribe({
        next : (res) => {
          if(res.status==200 || res.status==201) {
            this.toastMsgService.setMsg({msg : "Branch Updated Successfully!",msgTitle : "Success", msgType : "I"});
           // this.router.navigate(["/sign-in"]);
           this.dataFields();
           this.AirportList()
           this.showAirportPopup=false

          } else {
            const body : any = res.body;
            this.registerAirportErrorMsg(res.status,body?.result);
          } 

        },error : (err) => {

          this.registerAirportErrorMsg(err.status,err.error);
        }
      }
    )
  }

  registerAirportErrorMsg(status : number,msg : string) {
    if(status >=500) {
      this.toastMsgService.setMsg({msg : "Failed to Update Branch",msgTitle : "Warning", msgType : "W"});
    } else {

      this.toastMsgService.setMsg({msg : "Failed to Update Branch",msgTitle:  "Warning", msgType : "W"});
    } 
  }
  
  

  carrierCodeList:any=[]
  sourceCodeList:any=[]
sourceCodelist(){

  this.AirManagementService
  .sourceCodelist()
  .subscribe({
    next : (res:any) => {
      if(res) {
     let data=res
     this.sourceCodeList=data
     
      } else {
      
      } 
    },error : (err) => {

    }
  }
)
}
carrierCodelist(){

  this.AirManagementService
  .carrierlist()
  .subscribe({
    next : (res:any) => {
      if(res) {
     let data=res
     this.carrierCodeList=data
     
      } else {
      
      } 
    },error : (err) => {

    }
  }
)
}

onAddAirport(){
  this.action="new"

  this.showAirportPopup=true
  this.dataFields()
}
onlyNumberKey(event:any) {
     
  let charCode = (event.which) ? event.which : event.keyCode;
  if (charCode != 46 && charCode > 31
      && (charCode < 48 || charCode > 57))
      return false;
  return true;
}

sourceName(item:any){
  if(item){
   let code:any=[]
   console.log(this.sourceCodeList)
   console.log(item)
   code =this.sourceCodeList.filter((items:any)=>items.code===item.toString())
   console.log(code)
   if(code.length>0){
    return code[0].title}
    else{
return item
    }
  }else{
    return item
  }

}

onFileSelected(event: any): void {
    
  this.fileSelected=true;


this.selectedFile = event.target.files[0] ?? null;

}

uploadFile(){
this.fileSelected=true;

this.AirManagementService
.UploadMiles(this.selectedFile)
.subscribe({
  next : (res:any) => {
    if(res) {

    this.fileSelected=false
    this.selectedFile=null
    this.showAirportPopup=false

      this.toastMsgService.setMsg({msg : "Upload File Successfully!",msgTitle : "Success", msgType : "I"});

    } else {
    
    } 
  },error : (err) => {
    this.toastMsgService.setMsg({msg : "Failed to Upload File",msgTitle : "Warning", msgType : "W"});


  }
}
)
}

searchFilter(){
  this.AirportList()
}

nextPage(event:PageEvent) {
    
  let page:any = {};
  this.pageStr['number'] = event.pageIndex.toString();
  this.pageStr['size'] = event.pageSize.toString();
  this.AirportList()
  //this.getAllUser(page)

}
AirportList(){

  this.AirManagementService
  .branchlist()
  .subscribe({
    next : (res:any) => {
      if(res) {
     let data=res
     this.airportData=res
    //  if(data.result.content.length>0){
    //   this.pageStr.number=data.result['number']
    //   this.pageStr.size=data.result['size']
    // }
    // this.totalElements = data.result['totalElements'];
    // this.airportData=data.result['content']
      } else {
      
      } 
    },error : (err) => {

    }
  }
)
}
onlyNumberSpecialKey(event: any): boolean {
  let charCode = (event.which) ? event.which : event.keyCode;

  // Allow numbers (48-57), plus sign (+ which is 43), minus sign (- which is 45), and colon (: which is 58)
  if (
      (charCode >= 48 && charCode <= 57) ||  // Allow numbers
      charCode === 43 ||  // Allow plus sign (+)
      charCode === 45 ||  // Allow minus sign (-)
      charCode === 58     // Allow colon (:)
  ) {
      return true;
  }

  // Prevent default for other characters
  return false;
}
}
